import {
  MONTHLY_PENSION_1K,
  MONTHLY_PENSION_2K,
  MONTHLY_PENSION_3K,
  MONTHLY_PENSION_4K,
  MONTHLY_PENSION_5K,
} from './constants';

interface APY_CALCULATOR_PROPS {
  age: string;
  pensionAmount: string;
}

interface CalculationResult {
  monthlyInvestment: number;
  investmentDuration: number;
  totalAmount: number;
}
export const APY_CALCULATOR_FORMULA = ({
  age,
  pensionAmount,
}: APY_CALCULATOR_PROPS): CalculationResult => {
  if (
    age == undefined ||
    pensionAmount == undefined ||
    Number(age) <= 0 ||
    Number(pensionAmount) <= 0
  ) {
    return {
      monthlyInvestment: 0,
      investmentDuration: 0,
      totalAmount: 0,
    };
  }
  let monthlyInvestment;

  switch (pensionAmount) {
    case '1000':
      monthlyInvestment = MONTHLY_PENSION_1K[age];
      break;
    case '2000':
      monthlyInvestment = MONTHLY_PENSION_2K[age];
      break;
    case '3000':
      monthlyInvestment = MONTHLY_PENSION_3K[age];
      break;
    case '4000':
      monthlyInvestment = MONTHLY_PENSION_4K[age];
      break;
    case '5000':
      monthlyInvestment = MONTHLY_PENSION_5K[age];
      break;
    default:
      monthlyInvestment = 0;
  }

  // checking for undefined in case the key is not present in the monthly pension objects
  if (!monthlyInvestment) {
    return {
      monthlyInvestment: 0,
      investmentDuration: 0,
      totalAmount: 0,
    };
  }

  const investmentDuration = 60 - Number(age);
  const totalAmount = monthlyInvestment * investmentDuration * 12;

  return {
    monthlyInvestment,
    investmentDuration,
    totalAmount,
  };
};
